import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { sendSMSForAppDownload } from 'api/api';
import { logBannerLeadCollection } from 'app/events/Events';
import {
  Button, Col, Container, Form, Row, Spinner,
} from 'react-bootstrap';
import { validateRegex } from 'app/utilities';
import CustomModal from './CustomModal';

const appUrlLink = 'https://llocal.onelink.me/ALsT/webtoapp';
const isMobile = window.screen.width < 992;

const LeadCollection = ({
  showPromotionPopup, onHidePromotionPopup, source,
}) => {
  const [phoneNumber, setPhoneNumber] = useState('');
  const [submitStatus, setSubmitStatus] = useState('');
  const isPhoneDisabled = (
    !phoneNumber
    || phoneNumber.length !== 10
    || submitStatus === 'loading'
  );

  const handleSubmit = () => {
    setSubmitStatus('loading');
    sendSMSForAppDownload(phoneNumber).then(() => {
      setSubmitStatus('success');
      logBannerLeadCollection({
        phoneNumber,
        appUrlLink,
        Page: source,
      });
      setTimeout(() => {
        setSubmitStatus('');
        setPhoneNumber('');
        onHidePromotionPopup();
        if (isMobile) {
          window.open(appUrlLink, '_blank');
        }
      }, 2000);
    }).catch(() => {
      setSubmitStatus('error');
    });
  };

  return (
    <>
      <CustomModal
        show={showPromotionPopup}
        onHide={() => { onHidePromotionPopup(); }}
        size="lg"
        backdrop
        closeButton
        body={(
          <>
            <Button
              onClick={onHidePromotionPopup}
              className="close-button"
            >

              <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="20" cy="20" r="16.6667" fill="#E5E5E5" />
                <path d="M26.6667 13.3333L13.3334 26.6667M13.3334 13.3333L26.6667 26.6667" stroke="black" strokeWidth="2" strokeLinecap="round" />
              </svg>

            </Button>
            <Container className="download-app-container border-radius-16">
              <Row className="flex-md-row parent-section popup-bg">
                {/* Left Section: Text + Image */}
                <Col lg={9} md={12} xs={12} sm={12} className="d-flex align-items-center justify-content-center">
                  <div className="scan-section text-md-left pl-3 pb-0">
                    <h2 className="">
                      Guaranteed Freshness
                      <br />
                      <span className="mobile-banner-text">
                        From Your
                        <br />
                        <span className="font-weight-black">Trusted Local Stores</span>
                      </span>
                    </h2>
                    <div className="banner-offer">
                      <img src="/images/banner-offer.png" alt="QR Code" width="100%" height="100%" />
                    </div>
                  </div>
                </Col>

                {/* Right Section: Background Image */}
                <Col lg={3} md={12} xs={12} sm={12} className="popup-right-bg d-flex align-items-center justify-content-center" />
                <Col lg={3} md={12} xs={12} sm={12} className="d-flex align-items-center justify-content-center d-md-none">
                  <div className="mobile-banner-image-container">
                    <img src="/images/mobile-banner.png" alt="QR Code" width="100%" height="100%" className="mobile-banner-image" />
                  </div>
                </Col>
                <Col lg={12} md={12} xs={24} className="d-flex align-items-center justify-content-center hide-on-desktop">
                  <Button
                    onClick={() => window.open(appUrlLink, '_blank')}
                    className="btn-download ml-3 mr-3 mb-5 d-flex align-items-center justify-content-center"
                  >
                    Download The App Now
                    <div className="d-flex align-items-center justify-content-center ml-2">
                      <svg width="24" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fillRule="evenodd" clipRule="evenodd" d="M12.5 22C18.0228 22 22.5 17.5228 22.5 12C22.5 6.47715 18.0228 2 12.5 2C6.97715 2 2.5 6.47715 2.5 12C2.5 17.5228 6.97715 22 12.5 22ZM14.0657 7.93432C13.7533 7.6219 13.2467 7.6219 12.9343 7.93432C12.6219 8.24673 12.6219 8.75327 12.9343 9.06569L15.0686 11.2H8.00001C7.55818 11.2 7.20001 11.5582 7.20001 12C7.20001 12.4418 7.55818 12.8 8.00001 12.8H15.0686L12.9343 14.9343C12.6219 15.2467 12.6219 15.7533 12.9343 16.0657C13.2467 16.3781 13.7533 16.3781 14.0657 16.0657L17.5657 12.5657C17.8781 12.2533 17.8781 11.7467 17.5657 11.4343L14.0657 7.93432Z" fill="#B8238E" />
                      </svg>
                    </div>
                  </Button>
                </Col>
              </Row>

              <Row className="flex-md-row flex-column bg-gradient hide-on-mobile">
                <Col md={7} className="d-flex align-items-center justify-content-center">
                  <div className="scan-section pt-0 pl-2 pb-6">
                    <h2 className="font-weight-black mt-3 text-center">Download The App</h2>
                    <div className="qr-placeholder d-flex justify-content-center pt-0">
                      <img src="/images/qr-code-image.png" className="qr-image" alt="QR Code" width="100%" height="100%" />
                    </div>
                  </div>
                </Col>

                <Col md={2} className="d-flex align-items-center justify-content-center p-0 or-section">
                  <div className="border border-white border-end border-end-1 border-height" />
                  <div className="or-position">OR</div>
                </Col>

                {/* Right Section - Phone Input */}
                <Col md={15} className="d-flex align-items-center justify-content-center">
                  <div className="phone-section">
                    <h2 className="mb-4 scan-section-text text-center">
                      Get The LoveLocal App
                      <br />
                      Download Link On SMS
                    </h2>
                    <Form>
                      <Form.Group controlId="phoneNumber">
                        {/* <Form.Label>Enter your phone number</Form.Label> */}
                        <Form.Control
                          type="tel"
                          className="bg-purple custom-placeholder"
                          placeholder="Enter your mobile number"
                          pattern="[0-9]{10}"
                          minLength={10}
                          maxLength={10}
                          required
                          value={phoneNumber}
                          onChange={(e) => {
                            if (!validateRegex('phoneNumber', e.target.value)) {
                              return;
                            }
                            setPhoneNumber(e.target.value);
                          }}
                        />
                      </Form.Group>
                      <Button
                        color="primary"
                        className={`w-100 ${isPhoneDisabled ? 'bg-disabled' : 'bg-primary'} d-flex align-items-center justify-content-center`}
                        onClick={() => {
                          handleSubmit();
                        }}
                        disabled={isPhoneDisabled}
                      >
                        {submitStatus === 'loading' && (
                        <Spinner animation="border" size="sm" />
                        )}
                        {'  '}
                        <b>
                          Get Download Link On SMS
                        </b>
                        {'  '}
                        <div className="d-flex align-items-center justify-content-center">
                          <svg className={isPhoneDisabled ? 'icon-disabled' : 'icon-active'} width="24" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fillRule="evenodd" clipRule="evenodd" d="M12.5 22C18.0228 22 22.5 17.5228 22.5 12C22.5 6.47715 18.0228 2 12.5 2C6.97715 2 2.5 6.47715 2.5 12C2.5 17.5228 6.97715 22 12.5 22ZM14.0657 7.93432C13.7533 7.6219 13.2467 7.6219 12.9343 7.93432C12.6219 8.24673 12.6219 8.75327 12.9343 9.06569L15.0686 11.2H8.00001C7.55818 11.2 7.20001 11.5582 7.20001 12C7.20001 12.4418 7.55818 12.8 8.00001 12.8H15.0686L12.9343 14.9343C12.6219 15.2467 12.6219 15.7533 12.9343 16.0657C13.2467 16.3781 13.7533 16.3781 14.0657 16.0657L17.5657 12.5657C17.8781 12.2533 17.8781 11.7467 17.5657 11.4343L14.0657 7.93432Z" />
                          </svg>
                        </div>
                      </Button>
                    </Form>
                    {submitStatus === 'success' && (
                    <div className="pt-3 text-green fs-6 font-weight-bold">
                      Thanks! Check your SMS inbox for the LoveLocal App download link.
                    </div>
                    )}
                    {submitStatus === 'error' && (
                    <div className="pt-3 text-red fs-6 font-weight-bold">
                      Oops! something went wrong. Please retry.
                    </div>
                    )}
                  </div>
                </Col>
              </Row>
            </Container>
          </>
        )}
      />
    </>
  );
};

LeadCollection.propTypes = {
  showPromotionPopup: PropTypes.bool.isRequired,
  onHidePromotionPopup: PropTypes.func.isRequired,
  source: PropTypes.string.isRequired,
};

export default LeadCollection;
